import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

interface Props {
  rows: Array<any>;
  onDownload: (id: string, number: string) => void;
}

const CertificateHistoryTable: React.FC<Props> = ({ rows, onDownload }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Certificate No</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Certificate Type</TableCell>
            <TableCell>Issue Date</TableCell>
            <TableCell>Issued By</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.certificateNumber}</TableCell>
              <TableCell>{`${r.student.firstName} ${r.student.lastName}`}</TableCell>
              <TableCell>{r.template.name}</TableCell>
              <TableCell>{new Date(r.issueDate).toLocaleDateString()}</TableCell>
              <TableCell>{r.issuedBy || "-"}</TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => onDownload(r.id, r.certificateNumber)} title="Download PDF">
                  <DownloadIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No certificates
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CertificateHistoryTable;
